import React from 'react';

interface InputAdornmentProps {
  position?: 'start' | 'end';
  children?: React.ReactNode;
  className?: string;
}

const InputAdornment: React.FC<InputAdornmentProps> = ({
  position = 'end',
  children,
  className = '',
}) => {
  const positionClasses = {
    start: 'absolute left-3',
    end: 'absolute right-3',
  };

  return (
    <div className={`${positionClasses[position]} top-1/2 transform -translate-y-1/2 flex items-center ${className}`}>
      {children}
    </div>
  );
};

export default InputAdornment;

